import { useQuery } from "@tanstack/react-query";
import { TransportOrderService } from "./_request";

export const useQueryTransportOrderState = (params?: any) => {
  return useQuery({
    queryKey: ["queryOTState"],
    queryFn: async () => TransportOrderService.getSelectState(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};
